// True while the join flow is moving between steps: JoinLayout sets it from Nuxt's page
// loading hooks and dims the page area with its own cover for that time. The step being
// left stays on screen meanwhile, and the next step's fetch raises the shared
// joinStore.loading, so a step's own covers check this to stay off instead of stacking a
// second and third scrim over the layout's. AB#64268
export const useJoinStepChanging = () => useState<boolean>('join-step-changing', () => false)

/**
 * Whether a step's own loading cover should show: while joinStore.loading (or the page's
 * own `extra` flag) is set, except during a step change, when JoinLayout's cover dims the
 * page instead. One rule for every join step's cover. AB#64268
 */
export const useJoinStepLoading = (extra?: () => boolean) => {
  const joinStore = useJoinStore()
  const stepChanging = useJoinStepChanging()
  return computed(() => (joinStore.loading || !!extra?.()) && !stepChanging.value)
}
